import logo from '../assets/primary_red.svg';
import intersectionImage from '../assets/intersection.png';
import '../styles/App.css';
import { useState, React } from 'react';
import  {signIn, ResetPwd, ResetInitalPwd, LenelS2Connect}  from '../services/authService';
import SkeletonMain from './SkeletonMain';

import { Button, OpenInNewIcon } from './ui';
import {Box, Container, Typography, Grid, IconButton, TextField, FormControl, InputLabel, OutlinedInput, InputAdornment} from '@mui/material'

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import config  from '../utils/config.json';

function LoginPage() {

  var params = window.location.search;
  const urlParams = new URLSearchParams(params.toLowerCase());

  console.log(urlParams);

  var [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [code] = useState('');
  const [status, setstatus] = useState("init");
  const [showPassword, setShowPassword] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const language = getInitialLanguage();

  // const honeywellURL =
  //   `${window.origin}/redirector.html?dest=${encodeURIComponent(
  //     `${config.cogdomain}authorize?identity_provider=honeywellSSO&redirect_uri=${encodeURIComponent(`${window.origin}/redirector.html`)}&response_type=code&client_id=${config.clientId}&scope=openid`
  //   )}&source=${encodeURIComponent(window.location.origin)}`;

  const honeywellURL =
    `${config.redirect_page}?dest=${config.cogdomain}` +
    `authorize?identity_provider=honeywellSSO;redirect_uri=${config.redirect_page};` +
    `response_type=code;client_id=${config.clientId};scope=openid&source=${window.location.origin}`;

    if (urlParams.get("code")) {
      console.log("Lenel Connect user detected");
      LenelS2Connect(urlParams.get("code"));
      // this is if a user is comming to us anouncing they are a Lenel Connect user
    } else {
      console.log("Not a Lenel Connect user");
    }


  function getInitialLanguage() {
    const userLanguage = navigator.language;
    // Check if the user's language is in the supported languages
    const supportedLanguages = config.languages.map(lang => lang.code);
 
    if (supportedLanguages.includes(userLanguage)) {
      return userLanguage;
    } else {
      // Default to English if user's language is not supported
      return 'en-US';
    }
  }

  function handleSignIn() {
    setLoading(true);
    if (status ==="code") {
      ResetPwd(username, password,code, setstatus);
      
    } else if (status === "init")  {
      signIn(username, password, setstatus, setLoading);
      console.log('navigating...');
      // navigate('/');
    
    } else if (status === 'NEW_PASSWORD_REQUIRED'){
      ResetInitalPwd(status, username, password, setstatus)
    }
    // setTimeout(() => {
    //   setLoading(false);
    //   navigate('/main'); // Navigate to the main page
    // }, 2000); 

  };

  if (loading) {
    return (
      <SkeletonMain></SkeletonMain>
    );
  }

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">

      {/* Image background */}
      <img
        src={intersectionImage}
        alt=""
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      />

    <Container maxWidth="sm" sx={{ flex: 1, position: 'relative', zIndex: 1 }}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        mt={8}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.93)',
          borderRadius: 3,
          px: 5,
          py: 4,
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
          maxWidth: 480,
          width: '100%',
          mx: 'auto',
        }}
      >
        <img src={logo} alt="Logo" width="400" />
        <Typography variant="h6" align="center" mt={0} mb={5}>
          Honeywell HelpBot
        </Typography>
        <Typography variant="h6" align="center" mb={3}>
            <b>Sign in to ask your questions.</b>
          </Typography>

          {/* <Button
            icon={<OpenInNewIcon  strokeWidth={2} />}
            iconPosition="left"
            // onClick={function noRefCheck(){}}
            size="regular"
            variant="primary"
          >
            SALESFORCE SIGN IN
          </Button> */}
          <Button
            variant="primary"
            icon={<OpenInNewIcon  strokeWidth={2} />}
            iconPosition="left"
            onClick={() => {
              try {
                window.sessionStorage.setItem("product", "OnGuard");
                window.sessionStorage.setItem("version", "8.3");
                window.location.href = honeywellURL;
              } catch (error) {
                console.error('SSO redirect failed:', error);
                // Fallback or error message
              }
            }}
          >
              HONEYWELL SSO
          </Button>

          <Box alignItems="center" mt={2} mb={2}>
            <Button
              iconPosition="left"
              size="regular"
              variant="quiet-primary"
              onClick={()=> setShowLogin(!showLogin)}
            >
              OR SIGN IN WITH CREDENTIALS BELOW
            </Button>
          </Box>

          <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            {showLogin && <TextField
              fullWidth
              required
              id="username"
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              variant="outlined"
            />}
          </Grid>
          <Grid item xs={12}>
            {showLogin && <FormControl fullWidth variant="outlined" required>
              <InputLabel htmlFor="password">Password</InputLabel>
              <OutlinedInput
                autoComplete="off"
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                // onKeyUp={(e) => {
                //   if (e.key === 'Enter') handleSignIn();
                // }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
            </FormControl>
            }
            {showLogin && 
            <Box  display="flex" alignItems="center"  justifyContent="center" mt={2} mb={1}>
                <Button
                  onClick= {handleSignIn}
                  size="regular"
                  variant="primary"
                  disabled={!username || !password}
                >
                  Sign In
                </Button>
            </Box>
              
            }
            <Typography style={{ textAlign: 'center' , fontSize:'10px', color:'#5c5b5b', marginTop:'3px'}}>
            Responses are AI-generated. Accuracy not guaranteed. Always verify outputs. Don’t share personal data.
            </Typography>
          </Grid>
          
        </Grid>
        <Typography variant="body2" mt={showLogin?2 : 2} color="textSecondary" align="center">
            By signing in you agree to the Privacy Notice and EULA.
        </Typography>

        <Typography variant="body2" mt={2} color="textSecondary">
            <a href={config.privacy_statement_url} target="_blank" rel="noopener noreferrer">
                {config.languages.find(lang => lang.code === language).texts.privacynotice}
            </a>
            {' • '}
            {config.languages.find(lang => lang.code === language).texts.eulanotice}
          </Typography>
          

      </Box>
      </Container>
      <Box component="footer" textAlign="center" py={2} mt="auto" sx={{ position: 'relative', zIndex: 1 }}>
        <Typography variant="body2" color="textSecondary">
          {config.languages.find(lang => lang.code === language).texts.honeywell}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {config.languages.find(lang => lang.code === language).texts.rights}
        </Typography>
      </Box>
      </Box>
  );
}

export default LoginPage;
